import type { Episode } from '../types/podcast'

// Season 1 — Episodes 1 through 21 (Jan 2026 – Jun 2026)
export const season1Episodes: Episode[] = [
  {
    id: 21,
    title: "What's Your Problem — Scott Anderson (The End of Season 1)",
    guest: 'Scott Anderson',
    description:
      "Jason welcomes speaker and ministry leader Scott Anderson to the 3 Doves Podcast. Scott shares how he was born with cerebral palsy after his umbilical cord was wrapped around his neck, and how his parents' unwavering faith taught him to live in victory rather than as a victim. Scott has spoken all around the world, sharing his love of Jesus while serving as the bridge between 4KIDS Southwest Florida and local faith communities. The powerful finale to Season 1.",
    date: 'Jun 5, 2026',
    duration: '43 min',
    category: 'Testimony',
    spotifyUrl:
      'https://open.spotify.com/episode/2yCMgC8ziu25pxni8iOz7J?si=56eU2TrFSIWuLPVz56hWbg',
    verse: '2 Corinthians 12:9',
    verseText: 'My grace is sufficient; My power is perfected in weakness.',
  },
  {
    id: 20,
    title: 'Wrapped in the Cord, Held by Grace — Hannah Karius',
    guest: 'Hannah Karius',
    description:
      "On this episode of the 3 Doves Podcast, Hannah Karius shares how growing up in church gave her knowledge about Jesus, but motherhood and crisis led her into a real relationship with Him. Hannah recounts two terrifying birth experiences — including a code blue delivery during COVID lockdowns in New York and a second pregnancy where her baby was wrapped in the cord — and how God's grace held her family through it all.",
    date: 'May 29, 2026',
    duration: '57 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/5dO8hOus1KUlbeUG8Jxqsb?si=jUKQZdlBRASSMaHgwJiLNA',
    verse: 'Psalm 139:13',
    verseText: 'You knit me together in my mother’s womb.',
  },
  {
    id: 19,
    title: 'Mario Lara — The Occult to The Way',
    guest: 'Mario Lara',
    description:
      'A powerful story of transformation. Mario Lara shares his journey out of the occult and into the life-changing truth of Jesus — The Way, The Truth, and The Life. An honest conversation about freedom, deliverance, and walking in the light.',
    date: 'May 22, 2026',
    duration: '55 min',
    category: 'Testimony',
    spotifyUrl:
      'https://open.spotify.com/episode/4SFsOtTWStlzdmHcWhF8zQ?si=r3Bvt6b-StqPczGEaWPJRw',
    verse: 'Colossians 1:13',
    verseText: 'He rescued us from the dominion of darkness.',
  },
  {
    id: 18,
    title: 'Hope in the Middle of the Storm — Pastor Charlie Mitchell',
    guest: 'Pastor Charlie Mitchell',
    description:
      'On this episode of the 3 Doves Podcast, Pastor Charlie Mitchell shares his journey from growing up in Key West and Fort Myers, to losing his father to cancer at just 13 years old and stepping into adult responsibilities far too early. Charlie opens up about finding faith through youth ministry, missions work around the world, meeting his wife Erin in Copenhagen, and walking through deep loss, chronic illness, and a stage four kidney diagnosis that ultimately led to a life-saving transplant in 2023.',
    date: 'May 15, 2026',
    duration: '1 hr 1 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/5nLNKOKVfFp7UOUjvDl2Tx?si=Tzc-Tf3pRKSgTWEPxBTmzA',
    verse: 'Isaiah 43:2',
    verseText:
      'When you pass through the waters, they will not overwhelm you.',
  },
  {
    id: 17,
    title: "Krista Klossner — It's Okay to Not Be Okay PART 2",
    guest: 'Krista Klossner',
    description:
      "The conversation continues. In Part 2, Krista Klossner picks up where Part 1 left off — going deeper into her story of faith, surrender, and the truth that nothing is counted as a loss when you're walking with God.",
    date: 'May 9, 2026',
    duration: '50 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/7w8hZFEyNDiMk1ZtKYggMq?si=5h4g_NX2QlaCuCy-R6ysMg',
    verse: 'Jeremiah 29:11',
    verseText: 'Plans to give you a hope and a future.',
  },
  {
    id: 16,
    title: "Krista Klossner — It's Okay to Not Be Okay PART 1",
    guest: 'Krista Klossner',
    description:
      "Join us for a powerful conversation with Krista Klossner as she shares her story of faith, surrender, and discovering that nothing is counted as a loss when you're walking with God. In Part 1, Krista opens up about the moments that shaped her journey and the truth that it's okay to not be okay.",
    date: 'May 2, 2026',
    duration: '50 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/5Ypjxx0MxrjnUAg47wlq9O?si=PNtQOn0NTIiRdFw0tc9wQw',
    verse: 'Psalm 34:18',
    verseText: 'The Lord is close to the brokenhearted.',
  },
  {
    id: 15,
    title:
      'Take Refuge — Dolphin Trainer Erin Morrison — Living the Uncomfortable Life',
    guest: 'Erin Morrison',
    description:
      "Erin Morrison serves as the Ends Sailing Director for Ends Adventures. Erin felt called by God to pursue camp programs for at-risk youth, both overseas and locally. Having a background in biology, her heart is to use God's creation to show youth how deeply loved they are. Grounded in Romans 12:2, Erin talks about God's plan in providing Refuge for Erin going all in and not pursuing a life of comfort.",
    date: 'Apr 25, 2026',
    duration: '50 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/63Dwqu74u1ipzyw1Lfk2BN?si=4vWlLfk-SOq41uiPvsWQXQ',
    verse: 'Psalm 46:1',
    verseText:
      'God is our refuge and strength, a very present help in trouble.',
  },
  {
    id: 14,
    title: 'Matt Crosson — Walking by Faith in Business and Life',
    guest: 'Matt Crosson',
    description:
      'Matt Crosson joins the podcast to share his journey of faith through the world of business and everyday life. Matt opens up about the challenges, victories, and moments of surrender that have shaped his walk with God.',
    date: 'Apr 18, 2026',
    duration: '50 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/1VjWqTTxQ3OKNueDnMvmC1?si=7UPQYCXISkmWPT8BnFl2jg',
    verse: 'Isaiah 6:8',
    verseText: '“Here am I. Send me!”',
  },
  {
    id: 13,
    title: 'Streetlights — Cody Grube — Illuminating Scripture Through Music',
    guest: 'Cody Grube',
    description:
      'Cody Grube, founder of Streetlights, joins the podcast to share how he is making the Bible accessible through music and spoken word. Cody talks about his passion for bringing Scripture to life in a way that resonates with people from all walks of life.',
    date: 'Apr 11, 2026',
    duration: '55 min',
    category: 'Mission',
    spotifyUrl:
      'https://open.spotify.com/episode/6rWWtBOJcpCSI2vC7eErcc?si=gQwStn_bR-qQWFvJLEdwiA',
    verse: 'Proverbs 3:5–6',
    verseText: 'Trust in the Lord, and He will make your paths straight.',
  },
  {
    id: 12,
    title: "Who's Gonna Roll the Stone Away",
    guest: 'Jason Pawloski',
    description:
      "Host Jason Pawloski shares the Easter resurrection story from Mark 16:1–8, focusing on the women who go to Jesus' tomb wondering who will roll away the large stone, only to find it already moved and hear that Jesus has risen. He highlights how they walked in faith despite an obstacle they couldn't overcome, and connects the stone to the pressures, fear, regret, uncertainty, and hesitation people face today.",
    date: 'Apr 4, 2026',
    duration: '30 min',
    category: 'Easter',
    spotifyUrl:
      'https://open.spotify.com/episode/1iuDCgkwxrLBuMVk7auwTe?si=zgO0dRzWSGOPBCpD2ZV0xQ',
    verse: 'Mark 16:6',
    verseText: 'He is not here; He has risen.',
  },
  {
    id: 11,
    title: 'Music, Mission & Ministry — A Conversation with Iskander',
    guest: 'Iskander (Jesús Martínez)',
    description:
      'Born Jesús Martínez in Venezuela, Iskander is a dynamic reggae musician and passionate missionary whose work spans music, ministry, and humanitarian outreach worldwide. Through his powerful sound, he conveys messages of love, hope, and faith—reaching audiences across cultures while serving marginalized communities, from the homeless to at-risk youth. Whether on stage or in the field, Iskander uses his music and faith to make a lasting impact, one song and one mission at a time.',
    date: 'Mar 28, 2026',
    duration: '55 min',
    category: 'Mission',
    spotifyUrl:
      'https://open.spotify.com/episode/3bDtfcX8c7dRvH29wygmzB?si=7EqDTOw9TZqRwETk0tN6xA',
    verse: 'Matthew 5:39',
    verseText: 'Turn to them the other cheek.',
  },
  {
    id: 10,
    title:
      "Purpose at the Intersection — How Prayer, God's Protection and Healing Reached Others",
    guest: 'Wayne Schwartz',
    description:
      'In this part two conversation, Jason interviews Wayne Schwartz about how God "lined up" events surrounding Rachel\'s wedding and the serious car accident afterward. Wayne describes feeling a shock wave during the crash and believes God healed and protected him — leaving him without even a bruise — so he could be there for his family when they needed him most.',
    date: 'Mar 21, 2026',
    duration: '49 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/4OpAP35TOjPU15p1UKkAX3?si=VcWO4svuTzqPdTwkY41L0w',
    verse: 'James 5:16',
    verseText: 'Pray for one another that you may be healed.',
  },
  {
    id: 9,
    title: 'Death to Home: Living the Abundant Life',
    guest: 'The Schwartz Family',
    description:
      "Host Jason Pawloski interviews Wayne and Michelle Schwartz and their daughters, Emma and Rachel, about an Oct. 13 car crash in rural Michigan after a nephew's wedding. Their rental car entered a blinking-light intersection, was struck on the passenger side by a heavier vehicle, slammed into a wooden telephone pole — and what followed was a powerful story of faith, family, and the abundant life found even in the darkest moments.",
    date: 'Mar 14, 2026',
    duration: '51 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/4mIITXmQE29cGzkPj6i88B?si=-222unrAT_umMak7GhuWjg',
    verse: 'Psalm 91:11',
    verseText: 'He commands His angels to guard you in all your ways.',
  },
  {
    id: 8,
    title: 'Nothing is Wasted — Jimmy Akers — Addictions, Identity and Love',
    guest: 'Jimmy Akers',
    description:
      'Jimmy Akers blends his experience of 19+ years of serving people at their most critical intersections in life and providing support to help improve their mental health, as a clean, funny, speaker and storyteller. Jimmy has spoken 1,000+ times around the world, and shares his struggles with anxiety, depression, loss and a suicide attempt.',
    date: 'Mar 7, 2026',
    duration: '59 min',
    category: 'Identity',
    spotifyUrl:
      'https://open.spotify.com/episode/4YF0jNbcTWNam3nXdO88vS?si=Po7coKNCShyWl9Q6DB0Rkg',
    verse: 'Romans 8:28',
    verseText: 'God works all things together for good.',
  },
  {
    id: 7,
    title:
      'Corporate to Called — Francisco Shares His Rich Heritage of Family, Faith, and Favor',
    guest: 'Francisco Miyares Jr.',
    description:
      'In this compelling episode, Francisco Miyares Jr. opens up about his journey from the structure and success of the corporate world to answering a deeper calling on his life. Rooted in a rich heritage of family, faith, and favor, he shares how stepping away from a 15-year corporate career led him into full-time ministry and a life fully dedicated to advancing the Gospel.',
    date: 'Feb 28, 2026',
    duration: '52 min',
    category: 'Calling',
    spotifyUrl:
      'https://open.spotify.com/episode/79QQTpd7sZaxeIXfE2f1hc?si=PaCFBAHXQSGADxmAsXB9yA',
    verse: 'Ephesians 2:10',
    verseText:
      'We are created in Christ for the good works prepared for us.',
  },
  {
    id: 6,
    title: 'Addiction to Adventure - A Hike into the Presence of God',
    guest: 'Lexi Loofboro',
    description:
      'Lexi Loofboro loves anything that brings together faith, health, and people. She is married to her husband, Ian Loofboro, and together they serve the world through coaching, and their stand is to be love, hope and transformation. As a Hiking Director, Lexi takes those same passions and leads others to step away from the everyday and into adventures with God!',
    date: 'Feb 22, 2026',
    duration: '50 min',
    category: 'Adventure',
    spotifyUrl: 'https://spotifycreators-web.app.link/e/ZkygbZ4cX0b',
    verse: 'Psalm 121:1',
    verseText: 'I lift my eyes to the hills; where does my help come from?',
  },
  {
    id: 5,
    title: 'A Band of Brothers - The Power of Transformative Love',
    guest: 'Andrew, Caleb & JJ',
    description:
      'In this episode, Jason sits down with three college students — Andrew, Caleb, and JJ — to explore what it means to be brothers in Christ. They dive into the power of transformative love, how authentic brotherhood shapes faith, and why the next generation is hungry for real community rooted in Jesus.',
    date: 'Feb 14, 2026',
    duration: '48 min',
    category: 'Brotherhood',
    spotifyUrl:
      'https://open.spotify.com/episode/0GfsHrolJsi0UAOTYJmcP4?si=QIMcX_yIT9W2e0uy_CZ7lg',
    verse: 'Proverbs 17:17',
    verseText:
      'A friend loves at all times, and a brother is born for adversity.',
  },
  {
    id: 4,
    title: 'A Warriors Stance - Being in REAL Relationship',
    guest: 'Justin Hanneken',
    description:
      "In this episode of the Three Doves Podcast, host Jason Pawloski welcomes back guest Justin Hanneken, Executive Director of Ends of Earth Adventures and Associate Pastor. They delve into Justin's transformative journey, from starting cycling to building real, authentic relationships rooted in faith.",
    date: 'Feb 7, 2026',
    duration: '43 min',
    category: 'Relationships',
    spotifyUrl: 'https://open.spotify.com/episode/4Jci4PYyVQ7HoRSNHKKRBt',
    verse: '1 Corinthians 16:13',
    verseText: 'Stand firm in the faith, be courageous, be strong.',
  },
  {
    id: 3,
    title: 'A Warriors Ride to Salvation and Beyond',
    guest: 'Justin Hanneken',
    description:
      'In this episode, host Jason Pawloski sits down with Justin Hanneken, Executive Director of Ends of the Earth Adventures and associate pastor, for the first part of a powerful two-part conversation. Justin shares his remarkable journey from being lost to finding salvation and beyond.',
    date: 'Feb 1, 2026',
    duration: '42 min',
    category: 'Testimony',
    spotifyUrl:
      'https://open.spotify.com/episode/4n7iOViUYM8hg3L4P27v1U?si=9yeXgtkTSb-Lz69F0XpP1g',
    verse: '2 Corinthians 5:17',
    verseText: 'Anyone in Christ is a new creation.',
  },
  {
    id: 2,
    title:
      'Finding Identity and Purpose in God by Learning to "Be Still" Amidst Crisis and Betrayal',
    guest: 'Josh Phelps',
    description:
      'In this episode, we sit down with Josh Phelps, a man whose life story is a testament to the power of divine protection and the beauty of restoration. From the high-stakes world of law enforcement to the front lines of disaster restoration, Josh shares how God taught him to be still and find his true identity and purpose.',
    date: 'Jan 25, 2026',
    duration: '45 min',
    category: 'Faith',
    spotifyUrl:
      'https://open.spotify.com/episode/77Ie7kgLCKcZGh7EBAtJl3?si=_nUsG9ebSHOZEg2QEHBZCA',
    verse: 'Psalm 46:10',
    verseText: '“Be still, and know that I am God.”',
  },
  {
    id: 1,
    title: 'The Process of Pain',
    guest: 'Chris Horseman',
    description:
      "Pain is something we all try to avoid, yet it's often the very thing that shapes us most. In this episode, we sit down with Chris Horseman of Horseman's Landscape to talk honestly about what pain looks like when it shows up in real life — not as a theory, but as a process. Chris shares his journey through adversity, responsibility, and refinement, and how pain — when faced instead of escaped — can become a tool that forms character, resilience, and purpose.",
    date: 'Jan 17, 2026',
    duration: '1 hr',
    category: 'Growth',
    spotifyUrl:
      'https://open.spotify.com/episode/6BAT0ZmBNNcgxAslAVWTZh?si=hkqEEC3bTqu0TIhzjAYp4g',
    verse: 'Romans 5:3–4',
    verseText: 'Suffering produces perseverance, character, and hope.',
  },
]

export const SPOTIFY_SHOW_URL =
  'https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL'
